<template>
  <div>
    <p class="f-16 fw-600 mb-10">Trending now</p>
    <div class="tixstock-trending-badges">
      <span
        v-for="item in trendingCategories"
        :key="item._id"
        class="tixstock-trending-badge"
        @click="goToCategory(item)"
      >
        {{ item.title }}
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(['trendingCategories']),

  },

  methods: {
    goToCategory(category) {
          if (!category.slug) return;
          this.$router.push(`/international/event/${category._id}`);
        },
   
  },
};
</script>
<style scoped>
.tixstock-trending-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tixstock-trending-badge {
  font-size: 14px;
  padding: 4px 8px 5px 8px;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  border: 1px solid rgb(209, 220, 229);
  border-radius: 4px;
  white-space: nowrap;
  font-size: 13px;
  padding: 5px 8px;
  background-color: rgb(246, 248, 249);
  color: rgb(47, 52, 59);
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

.tixstock-trending-badge:hover {
  background: #000;
  color: #fff;
      border: 1px solid #000;
}
</style>
